<div class="content-container">
  <div class="form-container">
    <p *ngIf="isCreateType">
      <b>Note:</b> Barcode will automatically be downloaded upon submitting this form to create the
      medication.
    </p>
    <p *ngIf="isEditType">
      <b>Note:</b> Medication IDs cannot be changed. If you wish to edit a medication's ID, you must
      create a new medication.
    </p>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" id="form" #documentEditForm="ngForm" autocomplete="off">
      <div *ngIf="isCreateType">
        <div class="content-section">
          <div class="id-container">
            <emr-input type="text" label="Medication ID" [control]="idFormControl" [bottomSpace]="true"></emr-input>
            <button pButton pRipple type="button" class="p-button-outlined" label="Generate ID"
              (click)="generateID()"></button>
          </div>
        </div>

        <span *ngIf="hasIdError">
          <span *ngIf="hasIdRequiredError" class="error-msg"> ID is required. </span>
          <span *ngIf="hasIdMinLengthError" class="warn-msg">
            ID must be at least 4 characters.
          </span>
          <span *ngIf="hasIdUniqueEntryError" class="error-msg">
            This ID is already in use by another medication!
          </span>
        </span>
      </div>

      <!-- If editing, make ID uneditable since ID is used to specify the document to change -->
      <p *ngIf="isEditType">ID: {{ med.id }}</p>

      <div class="content-section">
        <emr-input type="text" label="Medication Name" [control]="nameFormControl"></emr-input><br />
        <emr-checkbox type="checkbox" label="Controlled Substance" [control]="controlledSubstanceFormControl" />
        <br />
        <emr-checkbox type="checkbox" label="Sliding Scale" [control]="slidingScaleFormControl" />
        <br />
        <emr-checkbox type="checkbox" label="Meal Time Coverage" [control]="mealTimesFormControl" />
      </div>

      <div class="content-section routes-container">
        <h3>Administration Routes</h3>
        <ng-container formArrayName="routes">
          <ng-container *ngFor="let routeFormGroup of routesFormArray.controls; let i = index" [formGroupName]="i">
            <div class="route-form-row">
              <span class="route-field-container">
                <label for="route-name">Route {{ i + 1 }}</label>
                <p-select id="route-name" class="input-field dropdown-field" placeholder="Select route name"
                  emptyMessage="No routes found." [options]="routes" formControlName="routeName"
                  styleClass="p-select-width" (onChange)="routeChanged(routeFormGroup)">
                </p-select>
                <span style="font-size: 0.8em">&nbsp;</span>
              </span>
              <span class="route-field-container" *ngIf="isOtherRoute(routeFormGroup)">
                <label for="other-name">Other Route Name</label>
                <input pInputText id="other-name" class="input-field" placeholder="Enter other name"
                  formControlName="otherName" />
                <span style="font-size: 0.8em">&nbsp;</span>
              </span>
              <button pButton pRipple type="button" icon="pi pi-trash"
                class="p-button-rounded p-button-secondary p-button-text" (click)="deleteRoute(i)"></button>
            </div>
          </ng-container>
          <button pButton pRipple type="button" class="p-button-outlined" label="Add Route" icon="pi pi-plus"
            (click)="addRoute()"></button>
        </ng-container>
      </div>
    </form>
  </div>
</div>
<div class="footer-container">
  <button pButton type="button" label="Cancel" (click)="onCancel()"></button>
  <button pButton pRipple type="button" label="{{ btnLabel }} Medication" [disabled]="isSubmitDisabled"
    (click)="onSubmit()"></button>
</div>